// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import Colours from '../../../styles/colours';

const useStyles = makeStyles(() => ({
  square: {
    width:           '14px',
    height:          '14px',
    backgroundColor: (props) => props.squareColor,
    marginRight:     '8px',
    border:          `1px solid ${Colours.Black}`,
  },
}));

const Square = ({ text, squareColor }) => {
  const classes = useStyles({ squareColor });

  return (
    <div className="d-flex align-items-center">
      <div className={clsx([classes.square])} />
      <Typography>{text}</Typography>
    </div>
  );
};

Square.propTypes = {
  text:        PropTypes.string,
  squareColor: PropTypes.string,
};

Square.defaultProps = {
  text:        '',
  squareColor: Colours.Gray,
};

export default Square;
